"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreePreviewMode = void 0;
var FreePreviewMode;
(function (FreePreviewMode) {
    FreePreviewMode["Social"] = "social";
    FreePreviewMode["NoSocial"] = "noSocial";
})(FreePreviewMode = exports.FreePreviewMode || (exports.FreePreviewMode = {}));
